import * as React from "react";
import { LocalTrackPublication, Participant, RemoteTrackPublication } from "twilio-video";
import useTrack from "../hooks/useTrack";
import { AudioTrack } from "./AudioTrack";
import VideoTrack from "./VideoTrack";

interface PublicationProps {
	publication: LocalTrackPublication | RemoteTrackPublication;
	participant: Participant;
	isLocalParticipant?: boolean;
}

export default function Publication({ publication, isLocalParticipant }: PublicationProps) {
	const track = useTrack(publication);

	if (!track) return null;

	switch (track.kind) {
		case "video":
			return <VideoTrack track={track} isLocal={track.name.includes("camera") && isLocalParticipant} />;
		case "audio":
			return <AudioTrack track={track} />;
		default:
			return null;
	}
}
